// Set-bonus resolver. ADR 0018 §4 (Codex review ISSUE I).
//
// `resolveActiveSetBonuses` is a pure function: given a character's equipped
// items, it counts matching pieces per set and returns the `SetBonus` tiers
// each set has activated. The sim reducer that applies the resolved bonuses is
// out of ADR 0018 scope (Phase 4).
import { SET_DEFINITIONS } from './sets.js';
const DEFINITION_BY_ID = new Map(SET_DEFINITIONS.map((def) => [def.id, def]));
/**
 * Count equipped pieces per set and return the active `SetBonus` tiers.
 *
 * A piece counts only when its `setId` resolves to a known set AND its `slot`
 * is one of that set's `slots`. Pieces are de-duplicated by slot (one item per
 * slot in real equipment). Sets with no active tier are omitted. Output order
 * follows the `SET_DEFINITIONS` catalogue order for determinism.
 */
export function resolveActiveSetBonuses(items) {
    const slotsBySet = new Map();
    for (const item of items) {
        if (item.setId === undefined)
            continue;
        const def = DEFINITION_BY_ID.get(item.setId);
        if (def === undefined)
            continue;
        if (!def.slots.includes(item.slot))
            continue;
        let slots = slotsBySet.get(item.setId);
        if (slots === undefined) {
            slots = new Set();
            slotsBySet.set(item.setId, slots);
        }
        slots.add(item.slot);
    }
    const resolved = [];
    for (const def of SET_DEFINITIONS) {
        const slots = slotsBySet.get(def.id);
        if (slots === undefined)
            continue;
        const equippedCount = slots.size;
        const activeBonuses = def.bonuses.filter((bonus) => bonus.piecesRequired <= equippedCount);
        if (activeBonuses.length === 0)
            continue;
        resolved.push({ setId: def.id, definition: def, equippedCount, activeBonuses });
    }
    return resolved;
}
//# sourceMappingURL=set-resolver.js.map